import MgmtSelect from "@/components/pages/mgmtSelect/Index.vue";

export default [
	{
		name: "MgmtSelect",
		path: "/mgmt_select",
		component: MgmtSelect,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜セレクト",
			column: "mgmt_select"
		}
	}
];
